import React from "react";

export const BrandMark = ({ size = 40, withWordmark = true, wordmarkClassName = "" }) => {
  return (
    <div className="flex items-center gap-3" data-testid="brand-mark">
      <img
        src="/brand/equitas-logo.png"
        alt="Equitas Homes"
        width={size}
        height={size}
        style={{ width: size, height: size }}
        className="rounded-full object-contain"
      />
      {withWordmark && (
        <div className={wordmarkClassName}>
          <div
            className="font-serif-display text-[17px] leading-none tracking-tight text-[#010082]"
            style={{ fontWeight: 600 }}
          >
            Equitas Homes
          </div>
          <div className="text-[10px] uppercase tracking-[0.22em] text-[#737373] mt-1">
            Louis Fong · Realtor
          </div>
        </div>
      )}
    </div>
  );
};
